module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/staff3-aa475c8e91c527008dc726cfad2a4d54.jpg";